import { Accordion as BaseAccordion } from './Accordion'
import { AccordionTab as Tab } from './AccordionTab'

export const Accordion = Object.assign(BaseAccordion, { Tab })
